import * as Sentry from "@sentry/browser";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import React from "react";
import { createRoot } from "react-dom/client";
import TagManager from "react-gtm-module";

import { HttpService } from "./httpService";
import "./i18n"; // Initialize i18n

import Layout from "./layout";
import settings from "./settings";
import { queryClient } from "./store/queryClient";

const isNotDevEnvironment = ["production", "staging"].includes(
  import.meta.env.REACT_APP_APPLICATION_ENV,
);

Sentry.init({
  dsn: "https://a2f62445ec59440aabafa1c08b002188@o242905.ingest.sentry.io/5222570",
  environment: import.meta.env.REACT_APP_APPLICATION_ENV,
  enabled: isNotDevEnvironment,
});

const tagManagerArgs = {
  gtmId: "GTM-TMJKX4G",
  dataLayer: {
    event: "initTracking",
    environment: settings.environment,
  },
};
TagManager.initialize(tagManagerArgs);

const instance = HttpService.getInstance();
instance.setupInterceptors();

const container = document.getElementById("root");
const root = createRoot(container!); // createRoot(container!) if you use TypeScript

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Layout />
      {!isNotDevEnvironment && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  </React.StrictMode>,
);
